// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  enrollKey: __t.string().primaryKey().name("enroll_key"),
  opId: __t.u64().name("op_id"),
  template: __t.string(),
  identity: __t.identity(),
  crewJson: __t.string().name("crew_json"),
  at: __t.timestamp(),
});
